export interface MarketBriefing {
  title: string;
  subtitle?: string;
  content: string;
  source: string;
  link: string;
}

export const marketBriefingFakeData: MarketBriefing[] = [
  {
    title: 'Harmony doubles dividend after gold price rally, flags lower copper output',
    subtitle: 'COMMODITIES',
    content:
      'The price of gold soared by about 60% in 2025, driven by geopolitical ​and economic uncertainty, expectations of U.S. interest rate cuts, and increased purchases by central banks amid a global de-dollarisation trend.',
    source: 'Reuters',
    link: 'https://www.reuters.com/world/africa/harmony-gold-half-year-profit-rises-13-dividend-up-2026-03-11/?utm_source=chatgpt.com',
  },
  {
    title:
      'Ivory Coast considers reforming cocoa marketing system to tackle excess supply, sources say',
    subtitle: 'MACRO',
    content:
      'Bitcoin rebounded above $73,000 on Friday, more than 15% above its February lows, even as the Iran conflict continued. Showing short-term strength versus gold and major stock indexes, the crypto rally was supported by $583 million worth of investor inflows into BTC ETFs this week, resulting in three consecutive weeks of positive gains.',
    source: 'Reuters',
    link: 'https://www.reuters.com/world/africa/ivory-coast-considers-reforming-cocoa-marketing-system-tackle-excess-supply-2026-03-12',
  },
];
